import { useMutation } from 'react-query'

import { useAxios } from 'hooks'

import { API_URL } from '../../utils/config'

export default function useDeleteGenericConclusion(data) {
  const instances = useAxios()
  const deleteGenericConclusion = async conclusionId => {
    const { data } = await instances.delete(
      `${API_URL}/conclusions/${conclusionId}/generic`
    )
    return data
  }
  return useMutation(data => deleteGenericConclusion(data), data)
}
